import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class VerificacionService {
  params: any;
  tokenNeo: string;
  token: string;

  saveParameters(params: any) {
    this.params = params;
  }

  getParameters() {
    return this.params;
  }

  saveTokenNeo(tokenNeo: string) {
    this.tokenNeo = tokenNeo;
  }

  getTokenNeo() {
    return this.tokenNeo;
  }

  saveToken(token: string) {
    this.token = token;
  }

  getToken() {
    return this.token;
  }
}
